import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ManageUserService } from '../manage-user.service';
import { Investor } from '../../shared/models/investor';
import { Observable } from 'rxjs/Observable';
import { User } from '../../../core/user';
import { AuthService } from '../../../core/auth.service';

@Component({
  selector: 'app-existing-user-investors',
  templateUrl: './existing-user-investors.component.html',
  styleUrls: ['./existing-user-investors.component.css']
})
export class ExistingUserInvestorsComponent implements OnInit {
  uid: string;
  pages: number;
  filter = {
    newStatus: false,
    mobileNo: '',
    email: '',
    name: ''
  };
  investorList: Investor[];
  nextbufferInvestorList: Investor[];
  prevbufferInvestorList: Investor[];
  currentUser: Observable<User>;
  currentUserData: User;
  constructor(
    private _Activatedroute: ActivatedRoute,
    private manageUserService: ManageUserService,
    private auth: AuthService,
    private router: Router, 
  ) {
    this.pages = 5;
    this.nextbufferInvestorList = [];
    this.prevbufferInvestorList = [];

  }

  ngOnInit() {
    this.uid = this._Activatedroute.snapshot.params['uid'];
    // const x = this.manageUserService.getInvestorByEditor(this.uid);
    // x.valueChanges().subscribe(item => {
    //   this.investorList = item;
    // });
    console.log('uid--:', this.uid);
    console.log('len:', this.prevbufferInvestorList.length);
    this.getCurrentUser();
    
  }
  getCurrentUser() {
    this.currentUser = this.auth.getCurrentUser();

    this.currentUser.subscribe(
      done => {
        console.log("done12", done);
        this.currentUserData = done;
        // if(!this.currentUserData.roles.superAdmin && !this.currentUserData.roles.admin && !this.currentUserData.roles.editor){
        //   this.filter.email = this.currentUserData.email;
        // }
        this.initialTasks();
      },
      error => {
        console.log('Error value', error);
      },
      () => {
        console.log('finished');
      }
    );
  }
  initialTasks(){
    const z = this.manageUserService.getFirstInvestor(this.uid, this.pages, this.filter.newStatus, (!this.currentUserData.roles.superAdmin && !this.currentUserData.roles.admin && !this.currentUserData.roles.editor)? this.currentUserData.email : this.filter.email, this.filter.mobileNo, this.filter.name);
    z.valueChanges().subscribe(item => {
      this.investorList = item;
      console.log((!this.currentUserData.roles.superAdmin && !this.currentUserData.roles.admin && !this.currentUserData.roles.editor)? "investor": "member")
      const y = this.manageUserService.getNextInvestor(
        this.uid,
        this.pages,
        this.investorList[this.investorList.length - 1],
        this.filter.newStatus, 
        (!this.currentUserData.roles.superAdmin && !this.currentUserData.roles.admin && !this.currentUserData.roles.editor)? this.currentUserData.email : this.filter.email, this.filter.mobileNo
      );
      y.valueChanges().subscribe(item2 => {
        this.nextbufferInvestorList = item2;
      });
    });
  }
  next() {
    this.prevbufferInvestorList = this.investorList.map(x =>
      Object.assign({}, x)
    );
    this.investorList = this.nextbufferInvestorList.map(x =>
      Object.assign({}, x)
    );
    const y = this.manageUserService.getNextInvestor(
      this.uid,
      this.pages,
      this.nextbufferInvestorList[this.nextbufferInvestorList.length - 1],
      this.filter.newStatus, this.filter.email, this.filter.mobileNo
    );
    y.valueChanges().subscribe(item => {
      this.nextbufferInvestorList = item;
      console.log('len:', this.prevbufferInvestorList.length);
    });
  }
  previous() {
    this.nextbufferInvestorList = this.investorList.map(x =>
      Object.assign({}, x)
    );
    this.investorList = this.prevbufferInvestorList.map(x =>
      Object.assign({}, x)
    );
    const y = this.manageUserService.getPreviousInvestor(
      this.uid,
      this.pages,
      this.prevbufferInvestorList[0],
      this.filter.newStatus, this.filter.email, this.filter.mobileNo
    );
    y.valueChanges().subscribe(item => {
      item.sort((a, b) => {
        if (a.updatedAt > b.updatedAt) {
          return 1;
        } else if (a.updatedAt < b.updatedAt) {
          return -1;
        } else {
          return 0;
        }
      });
      this.prevbufferInvestorList = item;
      console.log('len:', this.prevbufferInvestorList.length);
    });
  }
  filterInvestor() {
    this.ngOnInit();
  }
  redirectToNewApplication() {
    if(this.investorList && this.investorList.length == 0){
      this.router.navigate(['/checkup'])
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/manage-user/existing-user-investors/existing-user-investors.component.ts